export default class Gallery
{
	constructor()
	{
		this.images = document.querySelectorAll('a.gallery');
		this.images.length > 0 && this.initGalleries();
	}

	// initialize

	initGalleries()
	{
		this.showGallery = this.showGallery.bind(this);
		this.closeGallery = this.closeGallery.bind(this);
		this.zoomImg = this.zoomImg.bind(this);
		this.dragstart = this.dragstart.bind(this);
		this.drag = this.drag.bind(this);
		this.dragend = this.dragend.bind(this);
		this.touchstart = this.touchstart.bind(this);
		this.touchmove = this.touchmove.bind(this);
		this.touchend = this.touchend.bind(this);

		this.createStylesheet();

		this.galleries = [];
		this.rels = [];

		// create galleries

		this.images.forEach((image) =>
		{
			const rel = image.getAttribute('rel');

			image.addEventListener('click', this.showGallery);

			if(this.rels.indexOf(rel) === -1)
				this.rels.push(rel);
		});

		this.rels.forEach((rel, i) =>
		{
			// create gallery

			const gallery = document.createElement('div');

			gallery.className = 'gallery-lb fill';
			gallery.setAttribute('rel', rel);
			gallery.setAttribute('data-i', i);

			this.galleries.push(gallery);

			const bg = document.createElement('div');

			bg.className = 'bg fill';
			bg.addEventListener('click', this.closeGallery);

			gallery.appendChild(bg);

			const animWrap = document.createElement('div');

			animWrap.className = 'wrap fill';

			const animator = document.createElement('div');

			animator.className = 'animator fill';

			// create gallery items without src, load later

			const images = document.querySelectorAll('a.gallery[rel="' + rel + '"]');

			images.forEach((image) =>
			{
				const wrap = document.createElement('div');

				wrap.className = 'img';

				const img = document.createElement('img');

				img.setAttribute('data-src', image.getAttribute('href'));

				img.dataset.x = 0;
				img.dataset.y = 0;

				img.addEventListener('click', this.zoomImg);
				img.addEventListener('pointerdown', this.dragstart);

				wrap.appendChild(img);
				animator.appendChild(wrap);
			});

			animWrap.appendChild(animator);
			gallery.appendChild(animWrap);

			const close = document.createElement('a');

			close.href = 'javascript:;';
			close.className = 'close';
			close.innerHTML = `<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M31 1L1 31M31 31L1 1"/></g></svg>`;

			close.addEventListener('click', this.closeGallery);
			gallery.appendChild(close);

			const ctrls = document.createElement('div');

			ctrls.className = 'ctrls';

			const prev = document.createElement('a');

			prev.href = 'javascript:;';
			prev.className = 'prev';
			prev.dataset.dir = 'prev';
			prev.innerHTML = `<svg width="21" height="19" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M9.768 17.99L1.57 9.792l8.198-8.197M1.57 9.792h18.445"/></g></svg>`;
			prev.addEventListener('click', () => this.goTo(null, 'prev'));

			ctrls.appendChild(prev);

			images.forEach((image, i) =>
			{
				const ctrl = document.createElement('a');

				ctrl.href = 'javascript:;';
				ctrl.className = 'ctrl';
				ctrl.addEventListener('click', () => this.goTo(i, null));

				ctrls.appendChild(ctrl);
			});

			gallery.appendChild(ctrls);

			const next = document.createElement('a');

			next.href = 'javascript:;';
			next.className = 'next';
			next.dataset.dir = 'next';
			next.innerHTML = `<svg width="21" height="19" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M11.247 1.025l8.198 8.197-8.198 8.198M19.445 9.222H1"/></g></svg>`;
			next.addEventListener('click', () => this.goTo(null, 'next'));

			ctrls.appendChild(next);

			document.body.appendChild(gallery);
		});

		// keyboard key-bindings

		window.addEventListener('keyup', (e) =>
		{
			const key = e.keyCode;

			switch(key)
			{
				case 27:
					this.closeGallery();
				break;

				case 37:
					this.goTo(null, 'prev');
				break;

				case 39:
					this.goTo(null, 'next');
				break;
			}
		});

		this.initMobile();
	}

	// create gallery stylesheet

	createStylesheet()
	{
		const style = document.createElement('style');

		style.type = 'text/css';
		style.innerText = `.gallery-grid{width:calc(100% - 10px);max-width:1600px;margin:2% auto 0}.gallery-grid .img{padding-bottom:56.25%;margin:5px!important;-webkit-filter:grayscale(0);filter:grayscale(0);transition:-webkit-filter .2s ease;transition:filter .2s ease;transition:filter .2s ease,-webkit-filter .2s ease}.gallery-grid .img:hover{-webkit-filter:grayscale(1);filter:grayscale(1)}.gallery-lb{z-index:500;opacity:0;pointer-events:none;transition:opacity .45s ease}.gallery-lb.fill,.gallery-lb .fill{position:fixed;left:0;right:0;top:0;bottom:0}.gallery-lb.active{opacity:1;pointer-events:all}.gallery-lb .bg{content:"";background:hsla(0,0%,100%,.85);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);position:fixed;left:0;right:0;top:0;bottom:0}.gallery-lb .close{padding:2vw;position:absolute;right:0;top:0}.gallery-lb .wrap{display:flex;align-items:center;margin-bottom:calc(20px + 1vw);pointer-events:none;-webkit-transform:scale(.6);transform:scale(.6);transition:-webkit-transform .45s ease;transition:transform .45s ease;transition:transform .45s ease,-webkit-transform .45s ease}.gallery-lb.active .wrap{-webkit-transform:scale(1);transform:scale(1)}.gallery-lb .animator{display:flex;flex-flow:nowrap;transition:-webkit-transform .45s ease;transition:transform .45s ease;transition:transform .45s ease,-webkit-transform .45s ease}.gallery-lb .animator.no-transition{transition:0s}.gallery-lb .img{flex:0 0 100%;height:90%;-ms-grid-row-align:center;align-self:center}.gallery-lb .img img{flex:1;max-width:90%;max-height:100%;position:absolute;left:50%;top:50%;cursor:zoom-in;box-shadow:0 0 70px rgba(0,0,0,.3);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.gallery-lb .img img.transition{transition:-webkit-transform .15s ease;transition:transform .15s ease;transition:transform .15s ease,-webkit-transform .15s ease}.gallery-lb .img.zoom{padding-bottom:100vh}.gallery-lb .img.zoom img{min-width:100%;min-height:100%;max-width:none;max-height:none;cursor:-webkit-grab;cursor:grab}.gallery-lb .img.zoom img:active{cursor:-webkit-grabbing;cursor:grabbing}.gallery-lb.active .img img{pointer-events:all}.gallery-lb .ctrls{display:flex;justify-content:center;align-items:center;padding:2vw;position:absolute;left:0;right:0;bottom:0}.gallery-lb .ctrls>*{margin:0 6px}.gallery-lb .ctrl{background:#000;width:12px;height:12px;opacity:.3;border-radius:6px;transition:opacity .15s ease}.gallery-lb .ctrl.active,.gallery-lb .ctrl:hover{opacity:1}.gallery-lb .arrow{width:20px;height:20px}`;

		document.head.appendChild(style);
	}

	// find parent

	findParent(target)
	{
		while(target.parentNode)
		{
			target = target.parentNode;

			if(target.classList.value.indexOf('gallery') > -1)
				return target;
		}

		return null;
	}

	// show selected gallery

	showGallery(e)
	{
		e.preventDefault();

		let target = e.target;

		if(target.classList.value.indexOf('gallery') === -1)
			target = this.findParent(target);

		const rel = target.getAttribute('rel');
		const index = target.dataset.i !== undefined ? target.dataset.i : Array.from(target.parentNode.children).indexOf(target);

		const gallery = document.querySelector('.gallery-lb[rel="' + rel + '"]');
		const animator = gallery.querySelector('.animator');
		const images = gallery.querySelectorAll('img');

		images.forEach((image) => image.setAttribute('src', image.getAttribute('data-src')));

		animator.classList.add('no-transition');
		gallery.classList.add('active');

		setTimeout(() => animator.classList.remove('no-transition'), 450);

		this.goTo(index, null);
	}

	// close active gallery

	closeGallery()
	{
		const gallery = document.querySelector('.gallery-lb.active');

		if(gallery === null)
			return;

		gallery.classList.remove('active');

		const images = gallery.querySelectorAll('.img');

		images.forEach((image) => image.classList.remove('active'));
	}

	// go to selected index

	goTo(index, dir)
	{
		const animator = document.querySelector('.gallery-lb.active .animator');

		if(animator === null)
			return;

		this.clientX = 0;
		this.clientY = 0;

		const images = animator.querySelectorAll('.img');

		// if arrow keys / direction

		if(dir !== null)
		{
			const active = animator.querySelector('.img.active');

			let next;

			switch(dir)
			{
				case 'prev':
					next = active.previousSibling !== null ? active.previousSibling : images[images.length - 1];
				break;

				case 'next':
					next = active.nextSibling !== null ? active.nextSibling : images[0];
				break;
			}

			const i = Array.from(animator.children).indexOf(next);

			this.goTo(i, null);

			return;
		}

		if(index === null)
			return;

		index = parseInt(index);

		// zoom out of any zoomed images

		images.forEach((image) =>
		{
			const img = image.querySelector('img');

			img.classList.remove('no-click');

			img.dataset.x = 0;
			img.dataset.y = 0;

			img.style.transform = 'translate(-50%, -50%)';

			img.removeEventListener('pointermove', this.drag);
			img.removeEventListener('pointerup', this.dragend);

			if(image.classList.value.indexOf('zoom') > -1)
				image.classList.remove('zoom');
		});

		// set ctrl state

		const ctrls = document.querySelectorAll('.gallery-lb.active .ctrl');

		ctrls.forEach((ctrl, i) =>
		{
			ctrl.classList.remove('active');

			if(i === index)
				ctrl.classList.add('active');
		});

		animator.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';

		images.forEach((image) => image.classList.remove('active'));
		images[index].classList.add('active');
	}

	// zoom in to fill screen onClick

	zoomImg(e)
	{
		const img = e.target;
		const p = img.parentNode;

		setTimeout(() =>
		{
			if(img.classList.value.indexOf('no-click') > -1)
				return;

			let orientation = 'landscape';

			if(img.offsetHeight > img.offsetWidth)
				orientation = 'portrait';

			img.dataset.orientation = orientation;

			if(p.classList.value.indexOf('zoom') === -1)
			{
				p.classList.add('zoom');
				return;
			}

			img.classList.remove('transition');
			img.classList.remove('no-click');

			img.dataset.x = 0;
			img.dataset.y = 0;

			img.style.transform = 'translate(-50%, -50%)';

			p.classList.remove('zoom');
		}, 50);
	}

	// drag image around if bigger than viewport when zoomed

	dragstart(e)
	{
		e.preventDefault();

		const img = e.target;
		const p = img.parentNode;

		if(p.classList.value.indexOf('zoom') === -1)
			return;

		this.clientX = e.clientX - parseFloat(img.dataset.x);
		this.clientY = e.clientY - parseFloat(img.dataset.y);

		img.addEventListener('pointermove', this.drag);
		img.addEventListener('touchmove', this.drag);
		img.addEventListener('pointerup', this.dragend);
		img.addEventListener('touchend', this.dragend);
	}

	drag(e)
	{
		e.preventDefault();

		const img = e.target;
		const p = img.parentNode;

		if(p.classList.value.indexOf('zoom') === -1)
			return;

		img.classList.add('no-click');

		let clientX = e.clientX;
		let clientY = e.clientY;

		if(e.changedTouches && e.changedTouches.length)
		{
			clientX = e.changedTouches[0].clientX;
			clientY = e.changedTouches[0].clientY;
		}

		const x = (clientX - this.clientX);
		const y = (clientY - this.clientY);

		img.dataset.x = x;
		img.dataset.y = y;

		img.style.transform = 'translate3d(-50%, -50%, 0) translate3d(' + x + 'px, ' + y + 'px, 0)';
	}

	dragend(e)
	{
		e.preventDefault();

		const img = e.target;
		const rect = img.getBoundingClientRect();

		let x = parseInt(img.dataset.x);
		let y = parseInt(img.dataset.y);

		if(rect.x > 0)
			x = (x - rect.x);

		if(rect.y > 0)
			y = (y - rect.y);

		if(rect.right < window.innerWidth)
			x = (window.innerWidth / 2) - (rect.width / 2);

		if(rect.bottom < window.innerHeight)
			y = (window.innerHeight / 2) - (rect.height / 2);

		img.dataset.x = x;
		img.dataset.y = y;

		img.classList.add('transition');
		img.style.transform = 'translate3d(-50%, -50%, 0) translate3d(' + x + 'px, ' + y + 'px, 0)';

		img.removeEventListener('pointermove', this.drag);
		img.removeEventListener('touchmove', this.drag);
		img.removeEventListener('pointerup', this.dragend);
		img.removeEventListener('touchend', this.dragend);

		setTimeout(() =>
		{
			img.classList.remove('transition');
			img.classList.remove('no-click');
		}, 150);
	}

	// initialize mobile

	initMobile()
	{
		this.x = 0;
		this.dir = 'next';
		this.disabled = false;
		this.maxOpacity = 1;
		this.maxFilter = 4;
		this.activeIndex = 0;
		this.activeAnim = null;
		this.activeImages = null;
		this.active = null;
		this.next = null;

		this.galleries.forEach((gallery) =>
		{
			gallery.addEventListener('touchstart', this.touchstart);
			gallery.addEventListener('touchmove', this.touchmove);
			gallery.addEventListener('touchend', this.touchend);
		});
	}

	// mobile touchstart

	touchstart(e)
	{
		this.x = e.changedTouches[0].pageX;

		this.activeAnim = document.querySelector('.gallery-lb.active .animator');
		this.activeImages = this.activeAnim.querySelectorAll('.img');
		this.active = this.activeAnim.querySelector('.img.active');

		this.activeIndex = Array.from(this.active.parentNode.children).indexOf(this.active);

		this.activeAnim.classList.add('no-transition');
	}

	// mobile touchmove

	touchmove(e)
	{
		if(this.active && this.active.classList.value.indexOf('zoom') > -1)
			return;

		e.preventDefault();

		const diff = this.x - e.changedTouches[0].pageX;
		const amount = 'calc(-' + (this.activeIndex * 100) + '% - ' + diff + 'px)';

		this.dir = diff > 0 ? 'next' : 'prev';
		this.next = (this.dir === 'next' ? this.active.nextSibling : this.active.previousSibling);

		requestAnimationFrame(() =>
		{
			if(!this.disabled)
				this.activeAnim.style.transform = 'translate3d(' + amount + ', 0, 0)';
		});
	}

	// mobile touchend

	touchend()
	{
		if(this.active && this.active.classList.value.indexOf('zoom') > -1)
			return;

		this.disabled = true;

		const centers = [];

		this.activeAnim.classList.remove('no-transition');

		this.activeImages.forEach((image) =>
		{
			const center = image.getBoundingClientRect().left + (image.offsetWidth / 2);

			image.setAttribute('data-center', center);
			image.removeAttribute('style');

			centers.push(center);
		});

		const target = this.dir === 'next' ? (document.body.offsetWidth - 80) : 80;

		const nearest = centers.reduce((prev, curr) =>
		{
			return (Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev);
		});

		const closest = this.activeAnim.querySelector('.img[data-center="' + nearest + '"]');
		const closestIndex = Array.from(closest.parentNode.children).indexOf(closest);

		this.goTo(closestIndex, null);

		setTimeout(() => this.disabled = false, 450);
	}
}
